import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICategorie, ICreateCategorieRequest, IUpdateCategorieRequest } from 'src/app/shared/models/categorie';

@Injectable({ providedIn: 'root' })
export class CategorieService {

  private readonly apiUrl = '/api/v1/referentiel/categories';

  constructor(private http: HttpClient) {}

  getAll(): Observable<ICategorie[]> {
    return this.http.get<ICategorie[]>(this.apiUrl);
  }

  create(request: ICreateCategorieRequest): Observable<ICategorie> {
    return this.http.post<ICategorie>(this.apiUrl, request);
  }

  update(id: string, request: IUpdateCategorieRequest): Observable<ICategorie> {
    return this.http.patch<ICategorie>(`${this.apiUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  exportData(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/export`, { responseType: 'blob' });
  }
}